import { useState } from "react";
import edit from "../assets/images/navbar/orange-edit.png";

type Props = {
  image: string;
  itemName: string;
  itemPrice: number;
  discountedPrice: number;
  details: string;
  onCountChange?: (count: number) => void;
};

const RestaurantsItemCard = ({
  image,
  itemName,
  itemPrice,
  discountedPrice,
  details,
  onCountChange,
}: Props) => {
  return (
    <div className="py-[8px]">
      <div className="flex justify-between items-center">
        <div className="flex gap-[20px] items-center">
          <div className="flex items-center gap-4">
            <img
              src={image}
              alt="Food Item"
              className="h-[75px] w-[75px] rounded-[12px]"
            />
          </div>
          <div>
            <p className="text-[#050505] font-Urbanist text-[20px] font-medium leading-[20px]">
              {itemName}
            </p>
            <p className="text-[#FF8A00] font-Urbanist text-[14px] font-medium leading-[17px]">
              ₹{discountedPrice}{" "}
              <span className="line-through text-[#6A6A6A] ml-[15px] font-normal">
                ₹{itemPrice}
              </span>
            </p>
            <p className="text-[#050505] font-Urbanist text-[12px] font-normal leading-[17px]">
              {details}
            </p>
          </div>
        </div>

        <div>
          <button className="px-4 py-2 bg-[#F5F5F5] text-[#FF8A00] rounded-[8px] font-Urbanist font-medium text-[12px] leading-[15px]">
            <img
              src={edit}
              alt="Edit"
              className="h-[10px] w-[10px] inline-block mr-2"
            />{" "}
            Edit
          </button>
        </div>
      </div>
    </div>
  );
};

export default RestaurantsItemCard;
